/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import {
    useDataProvider,
    useNotify
} from "react-admin";
import { Link } from "react-router-dom";
import {
    Grid,
    Paper,
    Typography,
    Divider,
    Button as MUIButton
} from "@mui/material";

export const SiteHeader: React.FC<{ site: any }> = ({ site }) => {
  if (!site) return null;
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const handleGetInviteUrl = React.useCallback(async () => {
    try {
      const response = await dataProvider.getInviteUrl("sites", {
        id: site.id,
      });
      window.open(response, "_blank");
    } catch (error) {
      console.error(error);
      notify("Error fetching invite URL", { type: "error" });
    }
  }, [dataProvider, site, notify]);

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid size={{ xs: 12 }}>
          <Typography variant="h4" component="h1">
            {site.name ?? "Site"} — Aperçu
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Code interne : <strong>{site.internalCode}</strong>
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <MUIButton
            component={Link}
            to={`/sites/${site.id}`}
            variant="outlined"
            size="small"
            sx={{ mr: 1 }}
          >
            Voir la fiche
          </MUIButton>
          <MUIButton
            onClick={handleGetInviteUrl}
            color="warning"
            variant="outlined"
            size="small"
          >
            Lien espace client
          </MUIButton>
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="subtitle2">Adresse</Typography>
          <Typography>{site.address}</Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Typography variant="subtitle2">Code postal</Typography>
          <Typography>{site.zipCode}</Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Typography variant="subtitle2">Ville</Typography>
          <Typography>{site.city}</Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Typography variant="subtitle2">SIRET</Typography>
          <Typography>{site.siret}</Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Typography variant="subtitle2">Contact</Typography>
          <Typography>{site.contactName}</Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Typography variant="subtitle2">Téléphone</Typography>
          <Typography>{site.phone}</Typography>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Typography variant="subtitle2">Email</Typography>
          <Typography>{site.email}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};
